module.exports = require("mcore3");


//////////////////
// WEBPACK FOOTER
// external "mcore3"
// module id = 14
// module chunks = 0